// Редовете на избора в `FiscalInvoiceCreditAction`.
import type { TFunction } from "i18next";
import type { BillHistory } from "../../../../../api/reportsBillsHistory";

/** Ред на избора: причината, поради която не може, или „проверява се“. */
export interface CreditChoiceRowState {
  blockedReason: string | null;
  pendingText: string | null;
}

/** Двата пътя на кредитното известие — кой може и защо не. Само показване:
 *  BE отказва сам (право, вече кредитирана, принтерът на сесията). */
export const creditChoiceRows = (
  t: TFunction,
  {
    invoiceNumber,
    bill,
    billLoading,
    summaryLoaded,
    canCancel,
    canRestore,
    restoreHint,
    hasStornoPermission,
  }: {
    invoiceNumber: string;
    bill: BillHistory | null;
    billLoading: boolean;
    summaryLoaded: boolean;
    canCancel: boolean;
    canRestore: boolean;
    restoreHint: string | undefined;
    hasStornoPermission: boolean;
  },
): { reissue: CreditChoiceRowState; refund: CreditChoiceRowState } => {
  const both = (state: CreditChoiceRowState) => ({ reissue: state, refund: state });
  if (billLoading) return both({ blockedReason: null, pendingText: t("fiscalInvoice.credit.loading") });
  if (!bill) return both({ blockedReason: t("fiscalInvoice.credit.billMissing"), pendingText: null });
  // Сметката вече е с друга жива фактура (тази е кредитирана при „Възстанови“
  // и сметката е фактурирана наново) — известие към тази няма.
  if (bill.invoice_number && bill.invoice_number !== invoiceNumber) {
    return both({
      blockedReason: t("fiscalInvoice.credit.otherInvoice", { number: bill.invoice_number }),
      pendingText: null,
    });
  }
  const reissueReason = restoreHint ?? (canRestore ? null : t("fiscalInvoice.credit.notClosed"));
  const refundReason = !hasStornoPermission
    ? t("fiscalInvoice.credit.noStornoPermission")
    : summaryLoaded && !canCancel
      ? t("fiscalInvoice.credit.alreadyReversed")
      : null;
  return {
    reissue: { blockedReason: reissueReason, pendingText: null },
    refund: {
      blockedReason: refundReason,
      pendingText: refundReason || summaryLoaded ? null : t("fiscalInvoice.credit.loading"),
    },
  };
};
